/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponse } from '../models';
// @ts-ignore
import type { ApiV1DashboardActivitiesGet200Response } from '../models';
// @ts-ignore
import type { ApiV1DashboardStatisticsGet200Response } from '../models';
// @ts-ignore
import type { ApiV1DashboardSummaryGet200Response } from '../models';
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 대시보드 활동 내역 조회
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivities: async (limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 대시보드 결제수단 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardPaymentMethods: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 대시보드 통계 조회
         * @param {string} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStatistics: async (period?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 대시보드 요약 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 대시보드 활동 내역 조회
         * @param {string} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardActivities(limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DashboardActivitiesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardActivities(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getDashboardActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 대시보드 결제수단 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardPaymentMethods(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardPaymentMethods(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getDashboardPaymentMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 대시보드 통계 조회
         * @param {string} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardStatistics(period?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DashboardStatisticsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardStatistics(period, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getDashboardStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 대시보드 요약 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1DashboardSummaryGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getDashboardSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary 대시보드 활동 내역 조회
         * @param {DashboardApiGetDashboardActivitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardActivities(requestParameters: DashboardApiGetDashboardActivitiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardActivitiesGet200Response> {
            return localVarFp.getDashboardActivities(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 대시보드 결제수단 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardPaymentMethods(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse> {
            return localVarFp.getDashboardPaymentMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 대시보드 통계 조회
         * @param {DashboardApiGetDashboardStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardStatistics(requestParameters: DashboardApiGetDashboardStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardStatisticsGet200Response> {
            return localVarFp.getDashboardStatistics(requestParameters.period, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 대시보드 요약 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardSummary(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardSummaryGet200Response> {
            return localVarFp.getDashboardSummary(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - interface
 * @export
 * @interface DashboardApi
 */
export interface DashboardApiInterface {
    /**
     * 
     * @summary 대시보드 활동 내역 조회
     * @param {DashboardApiGetDashboardActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    getDashboardActivities(requestParameters?: DashboardApiGetDashboardActivitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardActivitiesGet200Response>;

    /**
     * 
     * @summary 대시보드 결제수단 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    getDashboardPaymentMethods(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse>;

    /**
     * 
     * @summary 대시보드 통계 조회
     * @param {DashboardApiGetDashboardStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    getDashboardStatistics(requestParameters?: DashboardApiGetDashboardStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardStatisticsGet200Response>;

    /**
     * 
     * @summary 대시보드 요약 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApiInterface
     */
    getDashboardSummary(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1DashboardSummaryGet200Response>;

}

/**
 * Request parameters for getDashboardActivities operation in DashboardApi.
 * @export
 * @interface DashboardApiGetDashboardActivitiesRequest
 */
export interface DashboardApiGetDashboardActivitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardApiGetDashboardActivities
     */
    readonly limit?: string
}

/**
 * Request parameters for getDashboardStatistics operation in DashboardApi.
 * @export
 * @interface DashboardApiGetDashboardStatisticsRequest
 */
export interface DashboardApiGetDashboardStatisticsRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardApiGetDashboardStatistics
     */
    readonly period?: string
}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI implements DashboardApiInterface {
    /**
     * 
     * @summary 대시보드 활동 내역 조회
     * @param {DashboardApiGetDashboardActivitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardActivities(requestParameters: DashboardApiGetDashboardActivitiesRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardActivities(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 대시보드 결제수단 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardPaymentMethods(options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardPaymentMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 대시보드 통계 조회
     * @param {DashboardApiGetDashboardStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardStatistics(requestParameters: DashboardApiGetDashboardStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardStatistics(requestParameters.period, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 대시보드 요약 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getDashboardSummary(options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getDashboardSummary(options).then((request) => request(this.axios, this.basePath));
    }
}

